"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentList = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/components/site-menu/component");
const component_2 = require("@front/layouts/default-layout/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="payment-list-page">  
    
    <crud-table 
      :onDataLoaded="${x => x.onDataLoaded}" 
      title="${'route.payment.list'.t()}" 
      resource="payment"
      searchPlaceholder="${'payment.search.placeholder'.t()}" 
      indexEndpoint="payment.index" 
      listEndpoint="payment.list"
      previewRoute="/payment/preview/:id"
      :columns="${x => x.tableColumns}"
      :noAdd="${x => true}"
      :canEdit="${x => false}"
      :canDelete="${x => false}"
      addRoute=""
      addText="">
    </crud-table>
  </div>
</div>`;
const styles = null;
const shadowOptions = { "mode": "open" };
let PaymentList = class PaymentList extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.tableColumns = [
            {
                key: 'sessionId',
                header: 'payment.sessionId'.t(),
                formatter: (value) => value || '-'
            },
            {
                key: 'provider',
                header: 'payment.provider'.t(),
                formatter: (provider) => {
                    let badgeClass = 'secondary';
                    let displayName = provider;
                    return `<span class="badge badge-${badgeClass}">${displayName}</span>`;
                }
            },
            {
                key: 'amount',
                header: 'payment.amount'.t(),
                formatter: (amount, row) => {
                    // Convert cents to dollars
                    const displayAmount = (amount / 100).toFixed(2);
                    return `$${displayAmount} ${row.currency || 'USD'}`;
                }
            },
            {
                key: 'description',
                header: 'payment.description'.t(),
                formatter: (value) => value ? (value.length > 50 ? value.substring(0, 50) + '...' : value) : '-'
            },
            {
                key: 'status',
                header: 'payment.status'.t(),
                formatter: (status) => {
                    let badgeClass = 'secondary';
                    let statusText = 'payment.status.unknown'.t();
                    switch (status) {
                        case backendImport_1.PaymentStatus.PENDING:
                            badgeClass = 'warning';
                            statusText = 'payment.status.pending'.t();
                            break;
                        case backendImport_1.PaymentStatus.SUCCESS:
                            badgeClass = 'success';
                            statusText = 'payment.status.success'.t();
                            break;
                        case backendImport_1.PaymentStatus.REJECTED:
                            badgeClass = 'danger';
                            statusText = 'payment.status.rejected'.t();
                            break;
                        case backendImport_1.PaymentStatus.ERROR:
                            badgeClass = 'danger';
                            statusText = 'payment.status.error'.t();
                            break;
                    }
                    return `<span class="badge badge-${badgeClass}">${statusText}</span>`;
                }
            },
            {
                key: 'paidAt',
                header: 'payment.paidAt'.t(),
                formatter: (paidAt) => {
                    if (!paidAt)
                        return '-';
                    const date = new Date(paidAt);
                    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
                }
            }
        ];
    }
    async connectedCallback() {
        var _a, _b, _c;
        const isSuperAdmin = ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
        const isParentUser = ((_b = component_2.DefaultLayout.USER) === null || _b === void 0 ? void 0 : _b.role) === backendImport_1.UserRoles.PARENT_USER || ((_c = component_2.DefaultLayout.USER) === null || _c === void 0 ? void 0 : _c.role) === backendImport_1.UserRoles.ENTERPRISE;
        if (isSuperAdmin || isParentUser) {
            // Add user column for admin users
            this.tableColumns.splice(1, 0, {
                key: 'user',
                header: 'payment.user'.t(),
                formatter: (user) => user ? `<a class="user-link" data-id="${user.id}" href="/user/list/${user.id}">${user.name || user.username}</a>` : '-'
            });
            // Add email column 
            this.tableColumns.splice(-2, 0, {
                key: 'email',
                header: 'payment.email'.t(),
                formatter: (email) => email || '-'
            });
        }
        super.connectedCallback();
    }
    onDataLoaded(data, totalPages, element) {
        if (data.length) {
            setTimeout(() => {
                var _a;
                const userLinks = (_a = element.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('a.user-link');
                userLinks === null || userLinks === void 0 ? void 0 : userLinks.forEach(userLink => {
                    userLink.onclick = (e) => {
                        e.preventDefault();
                        component_1.SiteMenu.goto.bind(this)(`/user/list/${userLink.dataset.id}`);
                    };
                });
            }, 0);
        }
    }
};
exports.PaymentList = PaymentList;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], PaymentList.prototype, "tableColumns", void 0);
exports.PaymentList = PaymentList = __decorate([
    (0, client_1.RWSView)('payment-list', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], PaymentList);
PaymentList.defineComponent();
